import type { InputProps } from '@monoimin/forms/gravity-form/types';

export const HiddenInput = ({ customId, label, defaultValue }: InputProps) => {
  return (
    <input
      id={customId}
      type={'hidden'}
      name={label || customId}
      defaultValue={defaultValue}
    />
  );
};
